import React, { ReactNode } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import styles from './ActivityFilter.module.scss';
import { FilterIcon } from '@repo/icons';
import { setActivityFilter } from '@repo/redux/actions/activity';
import { ActivityItemType } from '@repo/utils/models/Activity';
import { selectActiveActivityFilter } from '@repo/redux/reducers/data/activity';
import SelectMenu from '@components/Menus/SelectMenu';

interface ActivityFilterOption {
  label: ReactNode;
  value: ActivityItemType;
}

export const titleForActivityFilterType: Partial<Record<ActivityItemType, string>> = {
  'birthday': 'Birthdays',
  'event': 'Events',
  'new-member': 'New Members',
  'news': 'News',
  'diff': 'Social Changes',
  'post': 'Posts',
  'reconnect': 'Reconnect',
  'reminder': 'Reminders',
  'shared': 'Sharing',
};

const activityFilterOptions: ActivityFilterOption[] = [{ label: 'All', value: undefined }].concat(
  Object.keys(titleForActivityFilterType).map((value: ActivityItemType) => ({
    label: titleForActivityFilterType[value],
    value,
  })),
);

export default function ActivityFilterSetter({ disabled }: { disabled?: boolean }) {
  const dispatch = useDispatch();
  const filter = useSelector(selectActiveActivityFilter);

  return (
    <SelectMenu
      className={styles.filter}
      options={activityFilterOptions}
      value={filter}
      onChange={(value) => dispatch(setActivityFilter(value))}
      triggerClassName={cn(styles.filterTrigger, !!filter && styles.filterApplied)}
      disabled={disabled}
      triggerProps={{
        children: (
          <FilterIcon color="textPrimary" width="20" height="20" strokeWidth="1.2" hoverOpacity />
        ),
      }}
    />
  );
}
